import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { validateEmail, validatePhone, validatePostcode } from '../../../utils/formValidation/validationFunctions';


export const validate = (newEntry, initialStateOnEntry) => {
    let newErrors = {};

    newErrors = validatePostcode(newEntry.formPostcode, newErrors, 'formPostcode');
    newErrors = validatePhone(newEntry.formPhoneNumber, newErrors, 'formPhoneNumber');
    newErrors = validateEmail(newEntry.exitFormEmailAddress, newErrors, 'exitFormEmailAddress');
    newErrors = validateEmail(newEntry.sanctionFormFromEmailAddress, newErrors, 'sanctionFormFromEmailAddress');
    newErrors = validateEmail(newEntry.alternativeFromEmailAddress, newErrors, 'alternativeFromEmailAddress');
    newErrors = validatePostcode(newEntry.servicePostcode, newErrors, 'servicePostcode');

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialStateOnEntry);
    return newErrors;
};
